import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "header-wrapper-head" }
const _hoisted_3 = { class: "header-wrapper-fl" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = { class: "header-wrapper-fr" }

import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Dialog } from 'vant'
import { useStore } from 'vuex'

import { isAndroid } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default() {
      return ''
    }
  }
},
  setup(__props) {

const props = __props



const router = useRouter()
const route = useRoute()
const height = ref(25)
const isRoot = ref(true)
const store = useStore()

watch(
  () => route.path,
  () => {
    isRoot.value = route.path === '/' || route.path === '/info/detail'
  },
  {
    immediate: true
  }
)

const goBack = () => {
  router.back()
}

// ;(window as any).YMApi.systemBar.hide()

// try {
//   // eslint-disable-next-line @typescript-eslint/no-extra-semi
//   ;(window as any).YMApi.systemBar.requestInsets((insets: any) => {
//     // Dialog.alert({
//     //   title: '提示',
//     //   message: `${insets.top}`
//     // })
//     // if (isAndroid) {
//     //   height.value = 0
//     // } else {
//     //   height.value = insets.top
//     // }
//     height.value = insets.top
//   })
// } catch (error) {
//   console.log(error)
// }

// Vue.prototype.myPostMessage = function(param) {
//     if(Object.prototype.toString.call(param) == '[object Object]') param = JSON.stringify(param)
//     window.ReactNativeWebView.postMessage ? window.ReactNativeWebView.postMessage(param) : window.postMessage(param)
// }

const signOut = () => {
  try {
    if (store.getters.tenantType === 'daHua') {
      const params = JSON.stringify({ event: 'close' })
      // eslint-disable-next-line @typescript-eslint/no-extra-semi
      ;(window as any).ReactNativeWebView.postMessage
        ? (window as any).ReactNativeWebView.postMessage(params)
        : window.postMessage(params)
    } else {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-extra-semi
      ;(window as any).YMApi.window.close()
    }
  } catch (error) {
    Dialog.alert({
      title: '提示',
      message: '请在海康APP中调用'
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_sticky = _resolveComponent("van-sticky")!

  return (_openBlock(), _createBlock(_component_van_sticky, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "state-bar",
          style: _normalizeStyle({ height: `${height.value}px` })
        }, null, 4),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!isRoot.value)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "iconfont icon-back",
                  onClick: goBack
                }))
              : _createCommentVNode("", true),
            _createElementVNode("i", {
              class: "iconfont icon-cha",
              onClick: signOut
            })
          ]),
          (props.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(props.title), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "custom"),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "icon")
          ])
        ]),
        _renderSlot(_ctx.$slots, "nav")
      ])
    ]),
    _: 3
  }))
}
}

})